// [data-reveal] → adds .in once the element is 30% on screen (one-shot reveal; reduced motion: immediately).
const els = document.querySelectorAll('[data-reveal]:not(.in)');
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (reduce || !('IntersectionObserver' in window)) els.forEach((e) => e.classList.add('in'));
else {
  const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { threshold: 0.3 });
  els.forEach((e) => io.observe(e));
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-reveal]').forEach((x) => x.classList.add('in')));
}
